import React, {Component} from 'react'
import SAInputComponent from "../common/input/SAInputComponent";
import {FormattedMessage, injectIntl} from "react-intl";
import SAInputLabel from "../common/input/SAInputLabel";
import Constants from "../../services/Constants";
import {Card, Tabs} from "antd";
import ActiveDateSelect from "./ActiveDateSelect";
import {connect} from "react-redux";
import {MEDIA_BANNER_BMW, MEDIA_BANNER_MINI} from "./MediaType";
import UploadPictures from "../common/upload/UploadPictures";
import {SpinnerModal} from "../../public/components/SpinnerModal";

class BannerConfiguration extends Component {

  constructor(props) {
    super(props);
    this.state = {
      BANNER_BMW: {
        active: false,
        type: MEDIA_BANNER_BMW,
        medias:{},
      },
      BANNER_MINI: {
        active: false,
        type: MEDIA_BANNER_MINI,
        medias:{},
      },
      pristine: false
    }
  }

  componentDidMount() {
    this.props.dispatchFetchBanners();
  }

  componentWillReceiveProps(nextProps, nextContext) {

    if (nextProps.banners) {
      this.setState({...nextProps.banners})
    }
  }

  onSave = () => {
    const {BANNER_BMW, BANNER_MINI} = this.state;
    this.props.dispatchUpdateBanners({
      BANNER_BMW: {...BANNER_BMW, medias: this.convertFileDescription(BANNER_BMW.medias)},
      BANNER_MINI: {...BANNER_MINI, medias: this.convertFileDescription(BANNER_MINI.medias)},
    });
  };

  convertFileDescription = medias => {
    const mediasCopy = JSON.parse(JSON.stringify(medias));
    Constants.SUPPORTED_LANGUAGES.forEach(el => {
      if (medias[el] && medias[el].smartphone && medias[el].smartphone.key) {
        mediasCopy[el].smartphone = mediasCopy[el].smartphone.key
      }
      if (medias[el] && medias[el].tablet && medias[el].tablet.key) {
        mediasCopy[el].tablet = mediasCopy[el].tablet.key
      }
    });
    return mediasCopy;
  };

  onPropertyUpdate = (property, data) => {
    this.setState({[property]: data, pristine: true})
  };

  onLinkChange = (url, brand, lang) => {
    const property = this.state[brand];
    const {medias = {}} = property;
    medias[lang] = {...(medias[lang] || {}), url};
    this.setState({[brand]: property, pristine: true})
  };

  onBannerDelete = (picture, metadata) => {
    this.props.dispatchDeletePicture({key: picture.key, metadata});
    this.setState({pristine: true})
  };

  onBannerUpload = (file, metadata) => {
    const key = `public/${metadata.key}`;
    this.props.dispatchUploadPicture({key, file, metadata});
    this.setState({pristine: true})
    return false;
  };

  render() {
    const {intl: {formatMessage}, loading, errors = {}} = this.props;
    const {BANNER_BMW = {}, BANNER_MINI = {}, pristine} = this.state;

    return (
      <section className="box">
        <header className="box-heading">
          <h2 className="box-heading__title">
            <FormattedMessage id="section.communication.banner-configuration"/>
          </h2>
          <div className="box-heading__button">
            <button type="primary" disabled={!pristine} className="btn btn-sm btn-primary" onClick={() => this.onSave()}>
              <FormattedMessage id="action.save"/>
            </button>
          </div>
        </header>

        <div className="box__body">
          <div className="row">
            <SpinnerModal visible={loading}/>
            <div className="col-md-6 col-xxl-6">
              <h3 className="box__subtitle">BMW</h3>
              <ActiveDateSelect data={BANNER_BMW} errors={{from: errors['banners[BANNER_BMW].from'], to: errors['banners[BANNER_BMW].to']}}
                                  onChange={data => this.onPropertyUpdate("BANNER_BMW", data)} />

                <Tabs type="card" defaultActiveKey="en">
                  {Constants.SUPPORTED_LANGUAGES.map(lang => {
                    const bmwLang = BANNER_BMW.medias && BANNER_BMW.medias[lang] || {};
                    const error = errors[`banners[BANNER_BMW].medias[${lang}]`] || errors[`banners[BANNER_BMW].medias[${lang}].url`] || errors[`banners[BANNER_BMW].medias[${lang}].smartphone`] || errors[`banners[BANNER_BMW].medias[${lang}].tablet`]
                    return (
                      <Tabs.TabPane key={lang} tab={<span className={error ? 'txt-error': ''}>{formatMessage({id: lang})}</span>}>
                        <Card>
                          <div className="row">
                            <div className="col-md-6 col-xxl-6">
                              <SAInputComponent label={formatMessage({id: 'communication.smartphone'})}>
                                <UploadPictures allowUpload={(bmwLang.smartphone || []).length < 1} error={errors[`banners[BANNER_BMW].medias[${lang}]`] || errors[`banners[BANNER_BMW].medias[${lang}].smartphone`]}
                                            category={`banner/bmw/smartphone/${lang}`} accept={Constants.ALLOWED_IMAGE_TYPE}
                                            files={bmwLang.smartphone && [bmwLang.smartphone]}
                                            beforeUpload={file => this.onBannerUpload(file, {type:'BANNER_BMW', device:'smartphone', lg:lang, key:`banner/bmw/smartphone/${lang}`})}
                                            onRemove={() => this.onBannerDelete(bmwLang.smartphone, {type:'BANNER_BMW', device:'smartphone', lg:lang, key:`banner/bmw/smartphone/${lang}`})}/>
                              </SAInputComponent>
                            </div>
                            <div className="col-md-6 col-xxl-6">
                              <SAInputComponent label={formatMessage({id: 'communication.tablet'})}>
                                <UploadPictures allowUpload={(bmwLang.tablet || []).length < 1} error={errors[`banners[BANNER_BMW].medias[${lang}]`] || errors[`banners[BANNER_BMW].medias[${lang}].tablet`]}
                                            category={`banner/bmw/tablet/${lang}`} accept={Constants.ALLOWED_IMAGE_TYPE}
                                            files={bmwLang.tablet && [bmwLang.tablet]}
                                            beforeUpload={file => this.onBannerUpload(file, {type:'BANNER_BMW', device:'tablet', lg:lang, key:`banner/bmw/tablet/${lang}`})}
                                            onRemove={() => this.onBannerDelete(bmwLang.tablet, {type:'BANNER_BMW', device:'tablet', lg:lang, key:`banner/bmw/tablet/${lang}`})}/>
                              </SAInputComponent>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-12 col-xxl-12">
                              <SAInputLabel value={bmwLang.url}
                                            label="communication.banner.url"
                                            error={errors[`banners[BANNER_BMW].medias[${lang}]`] || errors[`banners[BANNER_BMW].medias[${lang}].url`]}
                                            onChange={e => this.onLinkChange(e.target.value, "BANNER_BMW", lang)}/>
                            </div>
                          </div>
                        </Card>
                      </Tabs.TabPane>
                    );
                  })}
                </Tabs>
              </div>

              <div className="col-md-6 col-xxl-6">
                <h3 className="box__subtitle">Mini</h3>
                <ActiveDateSelect data={BANNER_MINI} errors={{from: errors['banners[BANNER_MINI].from'], to: errors['banners[BANNER_MINI].to']}}
                                  onChange={data => this.onPropertyUpdate("BANNER_MINI", data)} />

                <Tabs type="card" defaultActiveKey="en">
                  {Constants.SUPPORTED_LANGUAGES.map(lang => {
                    const miniLang = BANNER_MINI.medias && BANNER_MINI.medias[lang] || {};
                    const error = errors[`banners[BANNER_MINI].medias[${lang}]`] || errors[`banners[BANNER_MINI].medias[${lang}].url`] || errors[`banners[BANNER_MINI].medias[${lang}].smartphone`] || errors[`banners[BANNER_MINI].medias[${lang}].tablet`]
                    return (
                      <Tabs.TabPane key={lang} tab={<span className={error ? 'txt-error': ''}>{formatMessage({id: lang})}</span>}>
                        <Card>
                          <div className="row">
                            <div className="col-md-6 col-xxl-6">
                              <SAInputComponent label={formatMessage({id: 'communication.smartphone'})}>
                                <UploadPictures allowUpload={(miniLang.smartphone || []).length < 1} error={errors[`banners[BANNER_MINI].medias[${lang}]`] || errors[`banners[BANNER_MINI].medias[${lang}].smartphone`]}
                                            category={`banner/mini/smartphone/${lang}`} accept={Constants.ALLOWED_IMAGE_TYPE}
                                            files={miniLang.smartphone && [miniLang.smartphone]}
                                            beforeUpload={file => this.onBannerUpload(file, {type:'BANNER_MINI', device:'smartphone', lg:lang, key:`banner/mini/smartphone/${lang}`})}
                                            onRemove={() => this.onBannerDelete(miniLang.smartphone, {type:'BANNER_MINI', device:'smartphone', lg:lang, key:`banner/mini/smartphone/${lang}`})}/>
                              </SAInputComponent>
                            </div>
                            <div className="col-md-6 col-xxl-6">
                              <SAInputComponent label={formatMessage({id: 'communication.tablet'})}>
                                <UploadPictures allowUpload={(miniLang.tablet || []).length < 1} error={errors[`banners[BANNER_MINI].medias[${lang}]`] || errors[`banners[BANNER_MINI].medias[${lang}].tablet`]}
                                            category={`banner/mini/tablet/${lang}`} accept={Constants.ALLOWED_IMAGE_TYPE}
                                            files={miniLang.tablet && [miniLang.tablet]}
                                            beforeUpload={file => this.onBannerUpload(file, {type:'BANNER_MINI', device:'tablet', lg:lang, key:`banner/mini/tablet/${lang}`})}
                                            onRemove={() => this.onBannerDelete(miniLang.tablet, {type:'BANNER_MINI', device:'tablet', lg:lang, key:`banner/mini/tablet/${lang}`})}/>
                              </SAInputComponent>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-12 col-xxl-12">
                              <SAInputLabel value={miniLang.url}
                                            label="communication.banner.url"
                                            error={errors[`banners[BANNER_MINI].medias[${lang}]`] || errors[`banners[BANNER_MINI].medias[${lang}].url`]}
                                            onChange={e => this.onLinkChange(e.target.value, "BANNER_MINI", lang)}/>
                            </div>
                          </div>
                        </Card>
                      </Tabs.TabPane>
                    )
                  })}
                </Tabs>
              </div>
            </div>
        </div>
      </section>
    )
  }
}

const mapStateToProps = state => ({
  banners: state.fetchNscBanners && state.fetchNscBanners.body,
  loading: state.fetchNscBanners.loading,
  errors: (state.fetchNscBanners.error || {}).content
});


const mapDispatchToProps = dispatch => ({
  dispatchFetchBanners: () => dispatch({type: 'FETCH.COMMUNICATION_BANNERS.REQUEST'}),
  dispatchUpdateBanners: body => dispatch({type: 'SAVE.COMMUNICATION_BANNERS.REQUEST', body}),
  dispatchUploadPicture: payload => dispatch({type: 'SAVE.BANNER_CONFIGURATION_FILE.REQUEST', payload}),
  dispatchDeletePicture: payload => dispatch({type: 'DELETE.BANNER_CONFIGURATION_FILE.REQUEST', payload})
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(BannerConfiguration));





// WEBPACK FOOTER //
// ./src/components/communication/BannerConfiguration.js